export default __webpack_public_path__ + "static/media/News & Announcements.242d75be.svg";